<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <!-- <div class="search_wrapper">
          <span class="search_label">次数</span>
          <Select v-model="testIndex" class="search_item" @on-change="recognitionTestRetestList">
            <Option v-for="(item,index) in testTotal" :value="index" :key="item">第{{index}}次</Option>
          </Select>
        </div>-->
      </div>
      <Table
        class="main_table"
        size="large"
        stripe
        border
        :height="clientHeight - 284"
        :columns="tableHeader"
        :data="tableData"
      >
        <template slot-scope="{ row, index}" slot="answerFormulaPic">
          <viewer :images="[trackUrl + row.image]">
            <img class="track_img" :src="trackUrlItem+ row.answerFormulaPic" />
          </viewer>
        </template>
        <template slot-scope="{ row, index}" slot="replyFormulaPic">
          <viewer :images="[trackUrl + row.image]">
            <img class="track_img" :src="trackUrlItem + row.replyFormulaPic" />
          </viewer>
        </template>
        <template slot-scope="{ row, index}" slot="image">
          <viewer :images="[trackUrl + row.image]">
            <img class="track_img" :src="positionUrl + row.image" />
          </viewer>
        </template>
        <!--<template slot-scope="{ row, index}" slot="track">-->
        <!--<a class="jump_color" :href="trackUrl + row.track" target="_blank">查看</a>-->
        <!--</template>-->
        <template slot-scope="{ row, index}" slot="lastScore">
          <a
            class="jump_color_score"
            :style="{color:parseInt(row.lastScore) ? '#0f0' : '#f00'}"
          >{{parseInt(row.lastScore) ? '√' : '×'}}</a>
        </template>
        <template slot-scope="{ row, index}" slot="action">
          <span class="hanle_click" @click="againScoring(row.id)">打分</span>
        </template>
        <!--<template slot-scope="{ row, index}" slot="flag">-->
        <!--<a class="jump_color_score" v-if="row.flag != 999" :style="{color:row.flag?'#0f0':'#f00'}">{{row.flag ? '√' : '×'}}</a>-->
        <!--<a class="jump_color" v-if="row.flag == 999">未批改</a>-->
        <!--</template>-->
      </Table>
    </div>
  </div>
</template>
<script>
import {
  _recognitionTestRetestList,
  _getQuestionTypeList,
  _recognitionTestRetest,
  _againScoring
} from "../api/api";
import { alertTips, dealDate } from "../common/common.js";
import global from "../common/Global";

export default {
  name: "OCRSetting",
  components: {},
  data() {
    return {
      clientHeight: 0, // 高度
      trackUrl: global.trackUrl, //轨迹数据前缀
      trackUrlItem: global.trackUrlItem, //蓝牙笔迹图片前缀--小题前缀
      positionUrl: global.positionUrl, // 图片前缀
      testIndex: 0, // 答题卡测试次数
      studentList: [], //学生列表
      testTotal: 0, // 测试次数
      questionTypeList: [], // 题目类型列表
      tableHeader: [
        {
          title: "识别得分",
          key: "lastScore"
        },
        {
          title: "识别配置",
          key: "recognitionParameterSnapshot"
        },
        {
          title: "录入答案",
          key: "answer"
        },
        {
          title: "录入答案转化",
          key: "answerFormulaPic",
          slot: "answerFormulaPic"
        },
        {
          title: "识别答案",
          key: "reply"
        },
        {
          title: "识别答案转化",
          key: "replyFormulaPic",
          slot: "replyFormulaPic"
        },
        {
          title: "识别结果",
          key: "lastScore",
          slot: "lastScore",
          sortable: true,
          filters: [
            {
              label: "只看对题",
              value: 1
            },
            {
              label: "只看错题",
              value: 2
            }
          ],
          filterMultiple: false,
          filterMethod(value, row) {
            let score = parseInt(row.lastScore);
            if (value === 1) {
              return score > 0;
            } else if (value === 2) {
              return score == 0;
            }
          }
        },
        {
          title: "书写轨迹",
          key: "image",
          slot: "image"
        },
        {
          title:"操作",
          key:"action",
          slot:"action"
        }
      ],
      tableData: []
    };
  },
  methods: {
//    从新打分
    againScoring(id){
      const self = this;
      let dataInfo = {data:id};
      _againScoring(dataInfo).then(res => {
        if(res.code === 0) {
          alertTips("success", "打分成功");
          self.getQuestionTypeList();
        }
      })
    },
    //      获取答題卡詳情
    recognitionTestRetestList() {
      _recognitionTestRetestList(this.id).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.map(item => {
            return item;
          });
          // this.testTotal = res.data.maxTestNumber + 1;
        }
      });
    },
    // 获取题目类型列表
    getQuestionTypeList() {
      const self = this;
      _getQuestionTypeList().then(res => {
        if (res.code === 0) {
          let dealArr = res.data.sort(function(m, n) {
            return m.id - n.id;
          });
          self.questionTypeList = dealArr;
          self.recognitionTestRetestList();
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //      获取高度
    getClientHeight() {
      this.clientHeight = document.documentElement.clientHeight;
    },
    //小题复测
    recognitionTestRetest(id) {
      _recognitionTestRetest(id).then(res => {
        if (res.code === 0) {
          this.$Message("success");
        }
      });
    },
    //小题复测
    navToRetestlist() {}
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.getClientHeight();
    this.getQuestionTypeList();
    window.addEventListener("resize", this.getClientHeight);
  }
};
</script>
<style scoped>
.ctrl-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.search_wrapper {
  width: 33.3%;
  display: flex;
  margin-right: 16px;
}
.search_wrapper:last-child {
  margin-right: 0;
}
.search_wrapper .search_label {
  display: inline-block;
  margin-right: 8px;
  line-height: 32px;
}
.search_wrapper .search_item {
  flex: 1;
  text-align: left;
}
.track_img {
  max-height: 80px;
  cursor: pointer;
}
.jump_color_score {
  padding: 15px 10px 15px 0;
  color: #2d8cf0;
  font-size: 36px;
  cursor: pointer;
}
.ocr_score_wrapper {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  margin-right: 60px;
}
.hanle_click {
  color: #2d8cf0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/OCRCardItemDetails.vue